export const GA4_CUSTOM_CLAN_DETAIL_CLICKED = 'connect-server-clicked'